/* eslint-disable */
import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import "../../styles/challanlist.css";
import "../../styles/time_table_management.css";
import {
    getActiveExamList,
    getExamTypeForTimeTable,
    getLanguageDetailsForTimeTable,
    addExamTimeTable,
    setAdmitCardTemplateDropdown,
    getselectExamListing,
    deletingData,
} from "../../../timetablemanagement/actions/timetableManagementAction";
import applicationstagesLabels from '../labels/applicationstages_en.json';
import { getFormattedDate } from "../../../helpers/Datetime";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import _ from "lodash/fp";
import { getAllExamSubjectsData } from "../../masterManagement/actions/masterManagementAction";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
import { toastr } from "react-redux-toastr";
import { setMinutes, setHours, addMinutes, isAfter } from "date-fns";
// import Devnagari from "../../masterManagement/components/devnagari";
import { GET_TIME_TABLE_LISTING } from "../../../common/constants/ActionTypes";
import commonLabels from '../../../common/labels/common_en.json';

const AddTimeTable = (props) => {
    const { register, control, errors, formState} = useForm({
        mode: "onChange",
    });
    let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const {
        getActiveExamListData,
        getExamType,
        getLanguageData,
        getAdmitCardTemplateList,
        getTimeTableDetails,
        getTimeTableExams,
    } = useSelector((state) => state.timeTableManagementReducer, shallowEqual);

    const { parentExamsubjectData } = useSelector(
        (state) => state.masterManagementReducer,
        shallowEqual
    );

    const dispatch = useDispatch();
    const [selectedExam, setSelectedExam] = useState("");
    const [selectExam, setSelectExam] = useState("");
    const [selectedExamDate, setSelectedExamDate] = useState("");
    const [presentTime, setPresentTime] = useState("");
    const [lastEnterTime, setLastEnterTime] = useState("");
    const [examStartTime, setExamStartTime] = useState("");
    const [examEndTime, setExamEndTime] = useState("");
    const [examSubject, setExamSubject] = useState("");
    const [subjectCode, setSubjectCode] = useState("");
    const [examType, setExamType] = useState("");
    const [language, setLanguage] = useState("");
    const [impInstruction, setImpInstruction] = useState("");
    const [candidateInstruction, setCandidateInstruction] = useState("");
    const [tempTimeTableData, setTempTimeTableData] = useState([]);
    const [authority, setAuthority] = useState(applicationstagesLabels.AUTHORITY_HI);
    const [signature, setSignature] = useState(applicationstagesLabels.SIGNATURE_HI);
    const [signatureLengthErr, setSignatureLengthErr] = useState(false);
    const [authorityLengthErr, setAuthorityLengthErr] = useState(false);
    const [examTemplate, setExamTemplate] = useState("");
    const [examTemplateErr, setExamTemplateErr] = useState(true);
    const [admitCardDisplayName, setAdmitCardDisplayName] = useState("");
    const [admitCardDisplayNameErr, setAdmitCardDisplayNameErr] = useState(true);
    const [admitCardTemplateList, setAdmitCardTemplateList] = useState([]);
    const [checkedValues, setCheckedValues] = useState([]);
    const [disableValue, setDisableValue] = useState(false);
    const [checkedValue, setCheckedValue] = useState("");
    const [existData, setExistData] = useState([]);
    const [selectedid, setSelectedID] = useState("");
    const [onlyselectedEXam, setOnlySelectedExam] = useState("");
    const [save, setSave] = useState(false);

    let TimeTableDetailsHeader = [
        "Sr. No.",
        "Exam Name",
        "Date of Examination",
        "Present Time",
        "Last Time of Enter Examination Hall",
        "Exam Start Time",
        "Exam End Time",
        "Exam Subject",
        "Language",
        "Subject Code",
        "Exam Type",
        "Action"
    ];

    useEffect(() => {
        dispatch({
            type: GET_TIME_TABLE_LISTING,
            payload: [],
        });
        setExistData([]);
        setTempTimeTableData([]);
    }, []);

    useEffect(() => {
        props && props.advtId && dispatch(getActiveExamList(props.advtId));
        dispatch(getExamTypeForTimeTable());
        dispatch(getAllExamSubjectsData());
        dispatch(getLanguageDetailsForTimeTable());
        dispatch(setAdmitCardTemplateDropdown());
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        if (getTimeTableExams && getTimeTableExams.timeTableExamsDtoList) {
            setExistData(getTimeTableExams.timeTableExamsDtoList);
        }
    }, [getTimeTableExams]);

    useEffect(() => {
        if (getTimeTableDetails && getTimeTableDetails.examInstructionsDtoList) {
            const filteredAdmitCardTemplateList =
                getAdmitCardTemplateList &&
                getAdmitCardTemplateList.filter((ele) => {
                    return !(
                        getTimeTableDetails && getTimeTableDetails.examInstructionsDtoList
                    ).some((template) => template.templateId === ele.id);
                });
            setAdmitCardTemplateList(filteredAdmitCardTemplateList);
        } else {
            setAdmitCardTemplateList(getAdmitCardTemplateList);
        }
    }, [getAdmitCardTemplateList, getTimeTableDetails]);

    const handleExamChange = (e) => {
        let examid = e.target.value;
        setSelectedExam(examid);
        setSelectExam(examid);
        dispatch(getselectExamListing(examid, true));
    };

    const handleSubjectChange = (value) => {
        setLanguage("");
        setExamSubject(value);
        parentExamsubjectData &&
            parentExamsubjectData.examSubjectList &&
            parentExamsubjectData.examSubjectList.map((e) => {
                if (e.id == value) {
                    setSubjectCode(e.code);
                }
            });
    };

    const cancelModal = () => {
        props.setShowAddTimeTableState(false);
        setSelectedExam("");
        setSelectedExamDate("");
        setPresentTime("");
        setLastEnterTime("");
        setExamStartTime("");
        setExamEndTime("");
        setExamSubject("");
        setSubjectCode("");
        setExamType("");
        setCandidateInstruction("");
        setImpInstruction("");
        setTempTimeTableData([]);
        setExamTemplate("");
        setExamTemplateErr(false);
        setAdmitCardDisplayName("");
        setAdmitCardDisplayNameErr(false);
        setExistData([]);
        dispatch({
            type: GET_TIME_TABLE_LISTING,
            payload: [],
        });

    };

    const handleSubmit = () => {
        let requestBody = {};

        tempTimeTableData &&
            tempTimeTableData.forEach((e) => {
                if (e.selectedExam) {
                    e.examId = e.selectedExam;
                }

                if (e.presentTime) {
                    let presentTimeVal = new Date(e.presentTime);
                    e.presentTime = presentTimeVal.toLocaleTimeString(applicationstagesLabels.itIT);
                }

                if (e.lastEnterTime) {
                    let getInTimeVal = new Date(e.lastEnterTime);
                    e.getInTime = getInTimeVal.toLocaleTimeString(applicationstagesLabels.itIT);
                }

                if (e.examStartTime) {
                    let examStartTimeVal = new Date(e.examStartTime);
                    e.durationFrom = examStartTimeVal.toLocaleTimeString(applicationstagesLabels.itIT);
                }

                if (e.examEndTime) {
                    let examEndTimeVal = new Date(e.examEndTime);
                    e.durationTo = examEndTimeVal.toLocaleTimeString(applicationstagesLabels.itIT);
                }

                if (e.subjectCode) {
                    e.subjectCodes = e.subjectCode;
                }

                if (e.language) {
                    e.timeTableExamSubjectsId = e.language;
                }

                if (e.examType) {
                    e.examPattern = e.examType;
                }

                return e;
            });
        let mergedArray = [...tempTimeTableData, ...existData];
        // mergedArray=[...mergedArray,...deletedData];
        requestBody.timeTableExamsDtoList = {};
        requestBody.templateId = examTemplate;
        requestBody.examDisplayName = admitCardDisplayName;
        requestBody.studentInstructions = candidateInstruction;
        requestBody.importantInstructions = impInstruction;
        requestBody.examAuthority = authority;
        requestBody.examAuthoritySignature = signature;
        requestBody.timeTableExamsDtoList = mergedArray;
        let flag = existData.length > 0 ? true : false;
        dispatch(addExamTimeTable(requestBody, props.advtId, selectExam, flag));
        props.setShowAddTimeTableState(false);
        setSelectedExam("");
        setSelectedExamDate("");
        setPresentTime("");
        setLastEnterTime("");
        setExamStartTime("");
        setExamEndTime("");
        setExamSubject("");
        setSubjectCode("");
        setExamType("");
        setCandidateInstruction("");
        setImpInstruction("");
        setTempTimeTableData([]);
        setExamTemplate("");
        setExamTemplateErr(false);
        setAdmitCardDisplayName("");
        setAdmitCardDisplayNameErr(false);
        cancelModal();
    };

    const findDuplicateObjects = (obj, arr) => {
        for (let i = 0; i < arr.length; i++) {
            const currentObject = arr[i];

            if (areObjectsEqual(obj, currentObject)) {
                return true;
            }
        }

        return false;
    };
    const areObjectsEqual = (obj1, obj2) => {
        const keys = Object.keys(obj1);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (key.includes("Time") || key === "examDate") {
                const date1 = new Date(obj1[key]).toISOString().slice(0, 19);
                const date2 = new Date(obj2[key]).toISOString().slice(0, 19);

                if (date1 !== date2) {
                    return false;
                }
            } else if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    };

    const onAddMoreTimeTableDetails = () => {
        if (
            // formState.isValid &&
            selectedExam &&
            selectedExamDate &&
            presentTime &&
            lastEnterTime &&
            examStartTime &&
            examEndTime &&
            examSubject &&
            subjectCode &&
            examType
        ) {
            if (tempTimeTableData && tempTimeTableData.length > 0) {
                tempTimeTableData &&
                    tempTimeTableData.forEach((e, index) => {
                        if (e.mode === "Edit") {
                            e.mode = "Add";
                            e.isDeleted = false;
                            e.selectedExam = selectedExam;
                            e.examDate = selectedExamDate;
                            e.presentTime = presentTime;
                            e.lastEnterTime = lastEnterTime;
                            e.examStartTime = examStartTime;
                            e.examEndTime = examEndTime;
                            e.examSubject = examSubject;

                            if (subjectCode == "042" || subjectCode == "043") {
                                e.language = language;
                            } else {
                                e.language = "";
                            }

                            e.subjectCode = subjectCode;
                            e.examType = examType;
                            setTempTimeTableData((prevData) => {
                                const updatedData = [...prevData];
                                updatedData[index] = e;
                                const unique2 = updatedData.filter((obj, index) => {
                                    return (
                                        index ===
                                        updatedData.findIndex(
                                            (o) =>
                                                obj.mode === o.mode &&
                                                obj.isDeleted === o.isDeleted &&
                                                obj.selectedExam === o.selectedExam &&
                                                obj.examDate === o.examDate &&
                                                obj.presentTime === o.presentTime &&
                                                obj.lastEnterTime === o.lastEnterTime &&
                                                obj.examStartTime === o.examStartTime &&
                                                obj.examEndTime === o.examEndTime &&
                                                obj.examSubject === o.examSubject &&
                                                obj.subjectCode === o.subjectCode &&
                                                obj.examType === o.examType
                                        )
                                    );
                                });
                                return unique2;
                            });
                            // setSelectedExam("");
                            setSelectedExamDate("");
                            setPresentTime("");
                            setLastEnterTime("");
                            setExamStartTime("");
                            setExamEndTime("");
                            setExamSubject("");
                            setSubjectCode("");
                            setExamType("");
                            toastr.success("Record Updated Successfully");
                        } else if (e.mode === "Add") {
                            let tempData = {};
                            tempData.mode = "Add";
                            tempData.isDeleted = false;
                            tempData.selectedExam = selectedExam;
                            tempData.examDate = selectedExamDate;
                            tempData.presentTime = presentTime;
                            tempData.lastEnterTime = lastEnterTime;
                            tempData.examStartTime = examStartTime;
                            tempData.examEndTime = examEndTime;
                            tempData.examSubject = examSubject;

                            if (subjectCode == "042" || subjectCode == "043") {
                                tempData.language = language;
                            }

                            tempData.subjectCode = subjectCode;
                            tempData.examType = examType;

                            const result = findDuplicateObjects(tempData, tempTimeTableData);
                            if (!result) {
                                setTempTimeTableData([...tempTimeTableData, tempData]);
                                // setSelectedExam("");
                                setSelectedExamDate("");
                                setPresentTime("");
                                setLastEnterTime("");
                                setExamStartTime("");
                                setExamEndTime("");
                                setExamSubject("");
                                setSubjectCode("");
                                setExamType("");
                            } else {
                                setTempTimeTableData([...tempTimeTableData]);
                                // toastr.error("Record Already Exits");
                            }
                        }
                    });
            } else {
                let tempData = {};
                tempData.mode = "Add";
                tempData.isDeleted = false;
                tempData.selectedExam = selectedExam;
                tempData.examDate = selectedExamDate;
                tempData.presentTime = presentTime;
                tempData.lastEnterTime = lastEnterTime;
                tempData.examStartTime = examStartTime;
                tempData.examEndTime = examEndTime;
                tempData.examSubject = examSubject;

                if (subjectCode == "042" || subjectCode == "043") {
                    tempData.language = language;
                }

                tempData.subjectCode = subjectCode;
                tempData.examType = examType;

                const result = findDuplicateObjects(tempData, tempTimeTableData);
                if (!result) {
                    setTempTimeTableData([...tempTimeTableData, tempData]);
                    // setSelectedExam("");
                    setSelectedExamDate("");
                    setPresentTime("");
                    setLastEnterTime("");
                    setExamStartTime("");
                    setExamEndTime("");
                    setExamSubject("");
                    setSubjectCode("");
                    setExamType("");
                } else {
                    setTempTimeTableData([...tempTimeTableData]);
                    toastr.error("Record Already Exits");
                }
            }
        } else if (
            onlyselectedEXam &&
            selectedExamDate &&
            presentTime &&
            lastEnterTime &&
            examStartTime &&
            examEndTime &&
            examSubject &&
            subjectCode &&
            examType
        ) {
            let languageName = getLanguageData.timeTableExamSubjectsDtoList.filter(
                (item) => item.id == language
            );
            let choosenSubject = parentExamsubjectData.examSubjectList.filter(
                (item) => item.id == examSubject
            );
            let tempData = {
                mode: "Edit",
                isDeleted: false,
                selectedExam: onlyselectedEXam,
                examDate: selectedExamDate,
                presentTime: presentTime,
                lastEnterTime: lastEnterTime,
                examStartTime: examStartTime,
                examEndTime: examEndTime,
                examSubject: choosenSubject[0]?.name,
                subjectCode: subjectCode,
                examType: examType,
            };

            if (subjectCode === "042" || subjectCode === "043") {
                tempData.language = language;
            }

            const date = new Date(examStartTime);
            const endDurationTo = new Date(examEndTime);
            const getTime = new Date(lastEnterTime);
            const present = new Date(presentTime);
            //   const date = new Date(examStartTime);
            const options = {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            };

            const formattedTime = date.toLocaleTimeString("en-US", options);
            const timeWithoutPM = formattedTime.substring(
                0,
                formattedTime.length - 3
            );

            const endTime = endDurationTo.toLocaleTimeString("en-US", options);
            const timeEndTime = endTime.substring(0, endTime.length - 3);

            const lastTime = getTime.toLocaleTimeString("en-US", options);
            const lastGetTime = lastTime.substring(0, lastTime.length - 3);

            const latestTime = present.toLocaleTimeString("en-US", options);
            const currentTime = latestTime.substring(0, latestTime.length - 3);
            const pattern = getExamType && getExamType.lookupOptionDtoList && getExamType.lookupOptionDtoList.length > 0 && getExamType.lookupOptionDtoList.filter(
                (item) => item.id == tempData.examType
            );

            const result = findDuplicateObjects(tempData, existData);
            if (!result) {
                let value = {
                    id: selectedid,
                    examId: tempData.selectedExam,
                    templateId: null,
                    examDate: tempData.examDate,
                    presentTime: currentTime,
                    getInTime: lastGetTime,
                    durationFrom: timeWithoutPM,
                    durationTo: timeEndTime,
                    subjectCodes: tempData.subjectCode,
                    subjectName: tempData.examSubject,
                    examPattern: tempData.examType,
                    examPatternName: pattern[0].label,
                    isActive: true,
                    isDeleted: false,
                    tableExamSubjectsDto: {
                        id: tempData.language,
                        subjectName: languageName[0]?.subjectName,
                        isActive: true,
                        isDeleted: false,
                    },
                };

                const updatedExistData = existData.map((item) =>
                    item.id == selectedid ? value : item
                );
                setExistData(updatedExistData);
                toastr.success("Record Updated successfully");
                setSave(true);
                setSelectedExam("");
                setSelectedExamDate("");
                setPresentTime("");
                setLastEnterTime("");
                setExamStartTime("");
                setExamEndTime("");
                setExamSubject("");
                setSubjectCode("");
                setExamType("");
            } else {
                toastr.error("Record Already Exists");
            }
        } else {
            toastr.error("Please fill all mandatory fields.");
        }
    };

    const formatAMPM = (date) => {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var strTime = hours + ":" + minutes + " " + ampm;
        return strTime;
    };

    const getExamName = (id) => {
        let ExamName =
            getActiveExamListData &&
            getActiveExamListData.length > 0 &&
            getActiveExamListData.map((e) => {
                if (e.id == id) {
                    return e.name;
                }
            });
        return ExamName;
    };

    const examSubjectName = (id) => {
        let ExamName =
            parentExamsubjectData &&
            parentExamsubjectData.examSubjectList &&
            parentExamsubjectData.examSubjectList.length > 0 &&
            parentExamsubjectData.examSubjectList.map((e) => {
                if (e.id == id) {
                    return e.name;
                }
            });
        return ExamName;
    };

    const examTypeName = (id) => {
        let ExamTypeName =
            getExamType && getExamType.lookupOptionDtoList &&
            getExamType.lookupOptionDtoList.length > 0 &&
            getExamType.lookupOptionDtoList.map((e) => {
                if (e.id == id) {
                    return e.label;
                }
            });
        return ExamTypeName;
    };

    const languageName = (id) => {
        let setLanguageName =
            getLanguageData &&
            getLanguageData.timeTableExamSubjectsDtoList &&
            getLanguageData.timeTableExamSubjectsDtoList.length > 0 &&
            getLanguageData.timeTableExamSubjectsDtoList.map((e) => {
                if (e.id == id) {
                    return e.subjectName;
                }
            });
        return setLanguageName;
    };

    const handleEditClick = (obj, index, value) => {
        if (value === "notExist") {
            setSelectedExam(obj.selectedExam);
            setSelectedExamDate(obj.examDate);
            setPresentTime(obj.presentTime);
            setLastEnterTime(obj.lastEnterTime);
            setExamStartTime(obj.examStartTime);
            setExamEndTime(obj.examEndTime);
            setExamSubject(obj.examSubject);
            setSubjectCode(obj.subjectCode);

            if (obj.examType) {
                setExamType(obj.examType);
            }
            tempTimeTableData &&
                tempTimeTableData.forEach((e, rowInd) => {
                    // if (index === rowInd) {
                    e.mode = "Edit";
                    // } else {
                    //   e.mode = "Add";
                    // }
                    return e;
                });
        } else {
            setSelectedID(obj.id);
            let exam = getActiveExamListData.filter((ele) => ele.id == obj.examId);
            let date = dayjs(obj.examDate).toDate();
            const originalDate = new Date(date);
            const monthNames = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ];

            const formattedDate = `${monthNames[originalDate.getMonth()]
                } ${originalDate.getDate()} ${originalDate.getFullYear()}`;

            let mergeDataPresentTime = dayjs(
                formattedDate + " " + obj.presentTime
            ).toDate();
            let mergeDatalastEnterTime = dayjs(
                formattedDate + " " + obj.getInTime
            ).toDate();
            let mergeDataExamStartTime = dayjs(
                formattedDate + " " + obj.durationFrom
            ).toDate();
            let mergeDataExamEndTime = dayjs(
                formattedDate + " " + obj.durationTo
            ).toDate();
            let subjectId = parentExamsubjectData.examSubjectList.filter(
                (item) => item.name === obj.subjectName
            );
            let examTypeId = getExamType && getExamType.lookupOptionDtoList && getExamType.lookupOptionDtoList.length > 0 && getExamType.lookupOptionDtoList.filter(
                (item) => item.label === obj.examPatternName
            );
            let languageId = getLanguageData.timeTableExamSubjectsDtoList.filter(
                (item) => item.subjectName == obj?.tableExamSubjectsDto?.subjectName
            );
            setOnlySelectedExam(obj.examId);
            setSelectedExam(exam.name);
            setSelectedExamDate(obj.examDate);
            setPresentTime(mergeDataPresentTime);
            setLastEnterTime(mergeDatalastEnterTime);
            setExamStartTime(mergeDataExamStartTime);
            setExamEndTime(mergeDataExamEndTime);
            setExamSubject(subjectId[0].id);
            setSubjectCode(obj.subjectCodes);
            if (examTypeId) {
                setExamType(examTypeId[0].id);
            }
            if (languageId) {
                setLanguage(languageId[0]?.id);
            }
            existData &&
                existData.forEach((e, rowInd) => {
                    e.mode = index === rowInd ? "Edit" : e.mode;
                });
        }
    };

    const handleDeleteClick = (obj, index, value) => {
        if (value === "notExist") {
            toastr.confirm("Are you sure you want to delete this record?", {
                onOk: () => {
                    const newArr = tempTimeTableData.filter((item, ind) => ind !== index);
                    setTempTimeTableData([...newArr]);
                    toastr.success("Record deleted successfully");
                    // setSelectedExam("");
                    setSelectedExamDate("");
                    setPresentTime("");
                    setLastEnterTime("");
                    setExamStartTime("");
                    setExamEndTime("");
                    setExamSubject("");
                    setSubjectCode("");
                    setExamType("");
                    // setExistData([]);
                },
            });
        } else {
            toastr.confirm("Are you sure you want to delete this record?", {
                onOk: () => {
                    const newArr = existData.filter((item) => item.id !== obj.id);
                    setExistData([...newArr]);

                    const deletedRecord = existData.find((item) => item.id === obj.id);
                    if (deletedRecord) {
                        const requestData = {
                            timeTableExamsDto: {
                                id: deletedRecord.id,
                                isDeleted: true,
                                isActive: false,
                            },
                        };
                        dispatch(deletingData(requestData));
                    }
                    setSelectedExam("");
                    setSelectedExamDate("");
                    setPresentTime("");
                    setLastEnterTime("");
                    setExamStartTime("");
                    setExamEndTime("");
                    setExamSubject("");
                    setSubjectCode("");
                    setExamType("");
                },
            });
        }
    };

    // const handleExamTemplateChange = (value) => {
    //   if (value) {
    //     setExamTemplate(value);
    //     setExamTemplateErr(false);
    //   } else {
    //     setExamTemplate(value);
    //     setExamTemplateErr(true);
    //   }
    // };

    // const handleAdmitCardDisplayNameChange = (value) => {
    //   if (value) {
    //     setAdmitCardDisplayName(value);
    //     setAdmitCardDisplayNameErr(false);
    //   } else {
    //     setAdmitCardDisplayName(value);
    //     setAdmitCardDisplayNameErr(true);
    //   }
    // };

    // const onCheckedValue = (e, item) => {
    //   const isChecked = e;
    //   setDisableValue(false);

    //   setCheckedValues((checkedValues) => {
    //     if (isChecked) {
    //       return [...checkedValues, item];
    //     } else {
    //       return checkedValues.filter((value) => value !== item);
    //     }
    //   });
    // };

    // const onAllCheckedValues = (e) => {
    //   setCheckedValue(e);
    //   if (e == true) {
    //     setCheckedValues(getTimeTableExams.timeTableExamsDtoList);
    //   } else {
    //     setCheckedValues([]);
    //   }
    // };
    let mergedArray = [...tempTimeTableData, ...existData];

    let tempDateFormatted = '';
    if (typeof selectedExamDate === 'number') {
        tempDateFormatted = new Date(selectedExamDate)
    } else {
        tempDateFormatted = new Date(selectedExamDate && selectedExamDate.getFullYear(), selectedExamDate && selectedExamDate.getMonth(), selectedExamDate && selectedExamDate.getDate());
    }
    const matchingEntry = mergedArray && mergedArray.find(entry => {
        let lastMatchingEntry = new Date(entry.examDate);
        return lastMatchingEntry && lastMatchingEntry.getDate() === tempDateFormatted.getDate() &&
            lastMatchingEntry && lastMatchingEntry.getMonth() === tempDateFormatted.getMonth() &&
            lastMatchingEntry && lastMatchingEntry.getFullYear() === tempDateFormatted.getFullYear();
    });

    let minTime = null;
    if (matchingEntry) {
        // const matchingEntries = mergedArray.filter(item => item.examDate === matchingEntry.examDate);
        const matchingEntries = mergedArray.filter(item => {
            const itemDate = new Date(item.examDate);
            const matchingEntryDate = new Date(matchingEntry.examDate);
            return itemDate.getTime() === matchingEntryDate.getTime();
        });
        if (matchingEntries.length > 1) {
            let matchingEntriesLength = matchingEntries.length - 1;
            const examEndTime = matchingEntries[matchingEntriesLength].examEndTime ? matchingEntries[matchingEntriesLength].examEndTime : "";
            const hours = examEndTime && examEndTime.getHours();
            const minutes = examEndTime && examEndTime.getMinutes();
            const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
            const durationToParts = matchingEntries[matchingEntriesLength].durationTo ? matchingEntries[matchingEntriesLength].durationTo.split(':') : formattedTime ? formattedTime.split(':') : '';
            const durationToHours = parseInt(durationToParts[0]);
            const durationToMinutes = parseInt(durationToParts[1]);
            minTime = setHours(setMinutes(new Date(), durationToMinutes), durationToHours);
        } else {
            const examEndTime = matchingEntry.examEndTime ? matchingEntry.examEndTime : "";
            const hours = examEndTime && examEndTime.getHours();
            const minutes = examEndTime && examEndTime.getMinutes();
            const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
            const durationToParts = matchingEntry.durationTo ? matchingEntry.durationTo.split(':') : formattedTime ? formattedTime.split(':') : '';
            const durationToHours = parseInt(durationToParts[0]);
            const durationToMinutes = parseInt(durationToParts[1]);
            minTime = setHours(setMinutes(new Date(), durationToMinutes), durationToHours);
        }
    }

    const filterPassedTime = (time) => {
        return time >= minTime;
    };

    const format24HrsAMPM = (time24) => {
        var time = time24.split(":");
        var hours = parseInt(time[0]);
        var minutes = parseInt(time[1]);
        var suffix = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        return hours + ":" + minutes + " " + suffix;
    };

    return (
        <div>
            <Modal
                size="xl"
                show={props.showAddTimeTableState}
                onHide={cancelModal}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
            >
                <Modal.Header  className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title className="logout_title"> {applicationstagesLabels.ADDS_TIME_TABLE}</Modal.Title>
                     <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={ onClick={cancelModal}}
                    >X</button>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.SELECT_EXAM}
                                    <span className="errorText">*</span>
                                </label>
                                <div className="input-group bg-color">
                                    <select
                                        className="form-select  bg-color"
                                        name="examName"
                                        value={selectedExam}
                                        defaultValue={selectedExam}
                                        onInput={handleExamChange}
                                        disabled={
                                            tempTimeTableData &&
                                                tempTimeTableData.length > 0 &&
                                                tempTimeTableData[0].selectedExam
                                                ? true
                                                : false
                                        }
                                        ref={register({ required: true })}
                                    >
                                        <option key={0} value="">
                                            {applicationstagesLabels.COMBO_SELECT}
                                        </option>
                                        {getActiveExamListData &&
                                            getActiveExamListData.length > 0 &&
                                            getActiveExamListData
                                                .filter((element) => element.isDeleted == false)
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                    </select>
                                </div>
                                {_.get("examName.type", errors) === "required" && (
                                    <p className="errorText float-start">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.DATE_OF_EXAMINATION}
                                    <span className="errorText">*</span>
                                </label>
                                <Controller
                                    name="dateAndTimeOfExam"
                                    defaultValue={
                                        selectedExamDate ? dayjs(selectedExamDate).toDate() : ""
                                    }
                                    rules={{ required: true }}
                                    control={control}
                                    render={({ onChange, value }) => (
                                        <div className="date-picker-container">
                                            <DatePicker
                                                selected={
                                                    selectedExamDate ? dayjs(selectedExamDate).toDate() : ""
                                                }
                                                showIcon
                                                minDate={new Date()}
                                                onChange={(e) => {
                                                    setSelectedExamDate(getFormattedDate(e));
                                                    onChange(getFormattedDate(e));
                                                }}
                                                icon={
                                                    <img
                                                        src="/icons/calender.png"
                                                        className="date-picker-icon"
                                                    ></img>
                                                }
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                placeholderText={
                                                    commonLabels.DATE_FORMAT_LABELS.DATE_FORMAT
                                                }
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control bg-color ps-2"
                                            />
                                        </div>
                                    )}
                                />
                                {_.get("dateAndTimeOfExam.type", errors) === "required" && (
                                    <p className="errorText">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.PRESENT_TIME}
                                    <span className="errorText">*</span>
                                </label>
                                <Controller
                                    name="presentTime"
                                    defaultValue={presentTime ? dayjs(presentTime).toDate() : ""}
                                    rules={{ required: true }}
                                    control={control}
                                    render={({ onChange, value }) => (
                                        <div className="date-picker-container">
                                            <DatePicker
                                                selected={presentTime}
                                                onChange={(e) => {
                                                    setPresentTime(e);
                                                    onChange(getFormattedDate(e));
                                                    setLastEnterTime("");
                                                    setExamStartTime("");
                                                    setExamEndTime("");
                                                }}
                                                showIcon
                                                showTimeSelect
                                                showTimeSelectOnly
                                                placeholderText="H:MM AA"
                                                dateFormat="h:mm aa"
                                                className="form-control bg-color ps-2"
                                                timeCaption="Time"
                                                minTime={minTime || setHours(setMinutes(new Date(), 0), 0)}
                                                maxTime={setHours(setMinutes(new Date(), 55), 23)}
                                                filterTime={filterPassedTime}
                                                icon={
                                                    <img
                                                        src="/icons/calender.png"
                                                        className="date-picker-icon"
                                                    ></img>
                                                }
                                            />
                                        </div>
                                    )}
                                />
                                {_.get("presentTime.type", errors) === "required" && (
                                    <p className="errorText">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.LAST_TIME_OF_ENTER_EXAMINITION_HALL}
                                    <span className="errorText">*</span>
                                </label>
                                <Controller
                                    name="lastEnterTime"
                                    defaultValue={
                                        lastEnterTime ? dayjs(lastEnterTime).toDate() : ""
                                    }
                                    rules={{ required: true }}
                                    control={control}
                                    render={({ onChange, value }) => (
                                        <div className="date-picker-container">
                                            <DatePicker
                                                selected={lastEnterTime}
                                                onChange={(e) => {
                                                    setLastEnterTime(e);
                                                    onChange(getFormattedDate(e));
                                                    setExamStartTime("");
                                                    setExamEndTime("");
                                                }}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                placeholderText="H:MM AA"
                                                dateFormat="h:mm aa"
                                                className="form-control bg-color ps-2"
                                                timeCaption="Time"
                                                minTime={
                                                    (presentTime &&
                                                        (isAfter(presentTime, setHours(setMinutes(new Date(), 0), 9))
                                                            ? addMinutes(presentTime, 30)
                                                            : setHours(setMinutes(new Date(), 30), 9))) || setHours(setMinutes(new Date(), 0), 0)
                                                }
                                                maxTime={setHours(setMinutes(new Date(), 55), 23)}
                                                showIcon
                                                icon={
                                                    <img
                                                        src="/icons/calender.png"
                                                        className="date-picker-icon"
                                                    ></img>
                                                }
                                            />
                                        </div>
                                    )}
                                />
                                {_.get("lastEnterTime.type", errors) === "required" && (
                                    <p className="errorText">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.EXAM_START_TIME}
                                    <span className="errorText">*</span>
                                </label>
                                <Controller
                                    name="examStartTime"
                                    defaultValue={
                                        examStartTime ? dayjs(examStartTime).toDate() : ""
                                    }
                                    rules={{ required: true }}
                                    control={control}
                                    render={({ onChange, value }) => (
                                        <div className="date-picker-container">
                                            <DatePicker
                                                selected={examStartTime}
                                                onChange={(e) => {
                                                    setExamStartTime(e);
                                                    onChange(getFormattedDate(e));
                                                    setExamEndTime("");
                                                }}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                placeholderText="H:MM AA"
                                                dateFormat="h:mm aa"
                                                className="form-control bg-color ps-2"
                                                timeCaption="Time"
                                                // minTime={setHours(
                                                //   setMinutes(
                                                //     lastEnterTime,
                                                //     lastEnterTime && lastEnterTime.getMinutes() - 30
                                                //   ),
                                                //   lastEnterTime && lastEnterTime.getHours()
                                                // )}
                                                minTime={
                                                    (lastEnterTime &&
                                                        (isAfter(lastEnterTime, setHours(setMinutes(new Date(), 0), 9))
                                                            ? addMinutes(lastEnterTime, 30)
                                                            : setHours(setMinutes(new Date(), 30), 9))) || setHours(setMinutes(new Date(), 0), 0)
                                                }
                                                maxTime={setHours(setMinutes(new Date(), 55), 23)}
                                                showIcon
                                                icon={
                                                    <img
                                                        src="/icons/calender.png"
                                                        className="date-picker-icon"
                                                    ></img>
                                                }
                                            />
                                        </div>
                                    )}
                                />
                                {_.get("examStartTime.type", errors) === "required" && (
                                    <p className="errorText">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>

                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.EXAM_END_TIME}
                                    <span className="errorText">*</span>
                                </label>
                                <Controller
                                    name="examEndTime"
                                    rules={{ required: true }}
                                    defaultValue={examEndTime ? dayjs(examEndTime).toDate() : ""}
                                    control={control}
                                    render={({ onChange, value }) => (
                                        <div className="date-picker-container">
                                            <DatePicker
                                                selected={examEndTime}
                                                onChange={(e) => {
                                                    setExamEndTime(e);
                                                    onChange(getFormattedDate(e));
                                                }}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                placeholderText="H:MM AA"
                                                dateFormat="h:mm aa"
                                                className="form-control bg-color ps-2"
                                                timeCaption="Time"
                                                // minTime={setHours(
                                                //   setMinutes(
                                                //     examStartTime,
                                                //     examStartTime && examStartTime.getMinutes() - 30
                                                //   ),
                                                //   examStartTime && examStartTime.getHours()
                                                // )}
                                                minTime={
                                                    (examStartTime &&
                                                        (isAfter(examStartTime, setHours(setMinutes(new Date(), 0), 9))
                                                            ? addMinutes(examStartTime, 30)
                                                            : setHours(setMinutes(new Date(), 30), 9))) || setHours(setMinutes(new Date(), 0), 0)
                                                }
                                                maxTime={setHours(setMinutes(new Date(), 55), 23)}
                                                showIcon
                                                icon={
                                                    <img
                                                        src="/icons/calender.png"
                                                        className="date-picker-icon"
                                                    ></img>
                                                }
                                            />
                                        </div>
                                    )}
                                />
                                {_.get("examEndTime.type", errors) === "required" && (
                                    <p className="errorText">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.EXAM_SUBJECT}
                                    <span className="errorText">*</span>
                                </label>
                                <div className="input-group bg-color">
                                    <select
                                        className="form-select  bg-color"
                                        name="examSubject"
                                        value={examSubject}
                                        // defaultValue={examSubject}
                                        onInput={(e) => handleSubjectChange(e.target.value)}
                                        ref={register({ required: true })}
                                    >
                                        <option key={0} value="">
                                            {applicationstagesLabels.COMBO_SELECT}
                                        </option>
                                        {parentExamsubjectData &&
                                            parentExamsubjectData.examSubjectList &&
                                            parentExamsubjectData.examSubjectList.length > 0 &&
                                            parentExamsubjectData.examSubjectList.map(
                                                (element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                )
                                            )}
                                    </select>
                                </div>
                                {_.get("examSubject.type", errors) === "required" && (
                                    <p className="errorText">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>

                            {(subjectCode == "042" || subjectCode == "043") && (
                                <div className="col-md-4">
                                    <label className="LeftText">
                                        {applicationstagesLabels.LANGUAGE}
                                        <span className="errorText">*</span>
                                    </label>
                                    <div className="input-group bg-color">
                                        <select
                                            className="form-select  bg-color"
                                            name="language"
                                            value={language}
                                            defaultValue={language}
                                            onInput={(e) => setLanguage(e.target.value)}
                                            ref={register({ required: true })}
                                        >
                                            <option key={0} value="">
                                                {applicationstagesLabels.COMBO_SELECT}
                                            </option>
                                            {getLanguageData &&
                                                getLanguageData.timeTableExamSubjectsDtoList &&
                                                getLanguageData.timeTableExamSubjectsDtoList.length > 0 &&
                                                getLanguageData.timeTableExamSubjectsDtoList.map(
                                                    (element, index) => (
                                                        <option key={index} value={element.id}>
                                                            {element.subjectName}
                                                        </option>
                                                    )
                                                )}
                                        </select>
                                    </div>
                                    {_.get("language.type", errors) === "required" && (
                                        <p className="errorText">
                                            {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                            )}

                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.SUBJECT_CODE}
                                    <span className="errorText">*</span>
                                </label>
                                <div className="input-group bg-color">
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="subjectCode"
                                        value={subjectCode}
                                        defaultValue={subjectCode}
                                        onChange={(e) => setSubjectCode(e.target.value)}
                                        disabled
                                        ref={register({ required: false })}
                                    />
                                </div>
                            </div>

                            <div className="col-md-4">
                                <label className="LeftText">
                                    {applicationstagesLabels.EXAM_TYPE}
                                    <span className="errorText">*</span>
                                </label>
                                <div className="input-group bg-color">
                                    <select
                                        className="form-select  bg-color"
                                        name="examType"
                                        value={examType}
                                        // defaultValue={examType}
                                        onInput={(e) => setExamType(e.target.value)}
                                        ref={register({ required: true })}
                                    >
                                        <option key={0} value="">
                                            {applicationstagesLabels.COMBO_SELECT}
                                        </option>
                                        {getExamType && getExamType.lookupOptionDtoList &&
                                            getExamType.lookupOptionDtoList.length > 0 &&
                                            getExamType.lookupOptionDtoList.map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.label}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                {_.get("examType.type", errors) === "required" && (
                                    <p className="errorText float-start">
                                        {applicationstagesLabels.MANDATORY_FIELD_MESSAGE}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="timeTableDetailsSection">
                        {/* <h5 className="float-start w-100 text-left">
              {applicationstagesLabels.TIME_TABLE_DETAILS}{" "}
            </h5> */}

                        <div className="row mt-2 mb-2">
                            <div className="col-md-4 form-group mb-0">
                                <button
                                    type="button"
                                    className="btn btn-sm  float-start btn-primary"
                                    onClick={() => onAddMoreTimeTableDetails()}
                                >
                                    {applicationstagesLabels.ADD_MORE_DETAILS}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="timeTableDetailsSection">
                        {((tempTimeTableData &&
                            tempTimeTableData.length > 0) || (existData &&
                                existData.length > 0)) &&
                            <div className="mt-3">
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            {TimeTableDetailsHeader &&
                                                TimeTableDetailsHeader.map((itm, ind) => (
                                                    <th key={ind} className='theadBgColor'>{itm}</th>
                                                ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {existData &&
                                            existData.length > 0 &&
                                            existData
                                                // .filter((item) => item.isDeleted != true)
                                                .map((item, indx) => {
                                                    const examName = getActiveExamListData.filter(
                                                        (ele) => ele.id == item.examId
                                                    );
                                                    return (
                                                        <tr key={indx}>
                                                            <td className="w-5 word-break text-center">
                                                                {indx + 1}
                                                            </td>
                                                            <td className="word-break">
                                                                {examName[0].name ? examName[0].name : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {days[new Date(item.examDate).getDay()]} ,{" "}
                                                                {item.examDate
                                                                    ? dayjs(item.examDate).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.presentTime ? format24HrsAMPM(item.presentTime) : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.getInTime ? format24HrsAMPM(item.getInTime) : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.durationFrom ? format24HrsAMPM(item.durationFrom) : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.durationTo ? format24HrsAMPM(item.durationTo) : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.subjectName ? item.subjectName : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item?.tableExamSubjectsDto
                                                                    ? item?.tableExamSubjectsDto?.subjectName
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.subjectCodes ? item.subjectCodes : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.examPatternName
                                                                    ? item.examPatternName
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break w-15">
                                                                <i
                                                                    role="button"
                                                                    data-toggle="tooltip"
                                                                    title={applicationstagesLabels.BUTTON_EDIT}
                                                                    onClick={() => {
                                                                        handleEditClick(item, indx, "Exist");
                                                                    }}
                                                                    className="text-primary fa fa-edit"
                                                                ></i>
                                                                &nbsp;&nbsp;
                                                                <i
                                                                    role="button"
                                                                    data-toggle="tooltip"
                                                                    className="fa fa-trash ms-2"
                                                                    title={applicationstagesLabels.BUTTON_DELETE}
                                                                    onClick={() => {
                                                                        handleDeleteClick(item, indx, "Exist");
                                                                    }}
                                                                ></i>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                        {tempTimeTableData &&
                                            tempTimeTableData.length > 0 &&
                                            tempTimeTableData
                                                .filter((item) => item.isDeleted != true)
                                                .map((item, index) => {
                                                    const examName = getActiveExamListData.filter(
                                                        (ele) => ele.id == item.examId
                                                    );
                                                    return (
                                                        <tr key={(existData &&
                                                            existData.length > 0) ? index + existData.length : index}>
                                                            <td className="w-5 word-break text-center">
                                                                {(existData &&
                                                                    existData.length > 0) ? (index + 1) + existData.length : index + 1}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.selectedExam
                                                                    ? getExamName(item.selectedExam)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {days[new Date(item.examDate).getDay()]} ,{" "}
                                                                {item?.examDate
                                                                    ? dayjs(item.examDate).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item?.presentTime
                                                                    ? formatAMPM(item?.presentTime)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item?.lastEnterTime
                                                                    ? formatAMPM(item.lastEnterTime)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item?.examStartTime
                                                                    ? formatAMPM(item.examStartTime)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.examEndTime
                                                                    ? formatAMPM(item.examEndTime)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.examSubject
                                                                    ? examSubjectName(item.examSubject)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.language
                                                                    ? languageName(item.language)
                                                                    : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.subjectCode ? item.subjectCode : ""}
                                                            </td>
                                                            <td className="word-break">
                                                                {item.examType
                                                                    ? examTypeName(item.examType)
                                                                    : ""}
                                                            </td>

                                                            <td className="word-break w-15">
                                                                <i
                                                                    role="button"
                                                                    data-toggle="tooltip"
                                                                    title={applicationstagesLabels.BUTTON_EDIT}
                                                                    onClick={() => {
                                                                        handleEditClick(item, (existData &&
                                                                            existData.length > 0) ? index + existData.length : index, "notExist");
                                                                    }}
                                                                    className="text-primary fa fa-edit"
                                                                ></i>
                                                                &nbsp;&nbsp;
                                                                <i
                                                                    role="button"
                                                                    data-toggle="tooltip"
                                                                    className="fa fa-trash ms-2"
                                                                    title={applicationstagesLabels.BUTTON_DELETE}
                                                                    onClick={() => {
                                                                        handleDeleteClick(item, (existData &&
                                                                            existData.length > 0) ? index + existData.length : index, "notExist");
                                                                    }}
                                                                ></i>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                    {/* <div>
            <div className="col-md-12 mt-2 mb-2 flex-grow-1 horizontalLineCss">
              <div className="row">
                <div className="col-md-4">
                  <label className="LeftText">
                    {applicationstagesLabels.SELECT_EXAM_TEMPLATE}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="examTemplate"
                    value={examTemplate}
                    defaultValue={examTemplate}
                    onInput={(e) => {
                      handleExamTemplateChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {admitCardTemplateList &&
                      admitCardTemplateList
                        .sort((a, b) => {
                          return Number(a.sortOrder) - Number(b.sortOrder);
                        })
                        .map((ele, ind) => {
                          return (
                            <option key={ind++} value={ele.id}>
                              {ele.label}
                            </option>
                          );
                        })}
                  </select>
                </div>

                <div className="col-md-4">
                  <label className="LeftText">
                    {applicationstagesLabels.EXAM_DISPLAY_NAME}
                    <span className="errorText">*</span>
                  </label>
                  <Controller
                    name="admitCardDisplayName"
                    control={control}
                    key="admitCardDisplayName"
                    defaultValue={admitCardDisplayName}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          handleAdmitCardDisplayNameChange(e);
                        }}
                        value={admitCardDisplayName}
                      />
                    )}
                  />
                </div>

                <div className="col-md-4">
                  <label className="LeftText">
                    {applicationstagesLabels.SIGNATURE}
                  </label>
                  <Controller
                    name="signature"
                    control={control}
                    key="signature"
                    defaultValue={signature}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          if (e.length <= 200) {
                            setSignature(e);
                            setSignatureLengthErr(false);
                          } else {
                            setSignatureLengthErr(true);
                          }
                        }}
                        value={signature}
                      />
                    )}
                  />
                  {signatureLengthErr && (
                    <p className="errorText">
                      {applicationstagesLabels.MAX_VALUE_FOR_200_CHAR}
                    </p>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="LeftText">
                    {applicationstagesLabels.AUTHORITY}
                  </label>
                  <Controller
                    name="authority"
                    control={control}
                    key="authority"
                    defaultValue={authority}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          if (e.length <= 200) {
                            setAuthority(e);
                            setAuthorityLengthErr(false);
                          } else {
                            setAuthorityLengthErr(true);
                          }
                        }}
                        value={authority}
                      />
                    )}
                  />
                  {authorityLengthErr && (
                    <p className="errorText">
                      {applicationstagesLabels.MAX_VALUE_FOR_200_CHAR}
                    </p>
                  )}
                </div>
              </div>
              <label className="LeftText mb-2 fw-bold ms-2">
                {applicationstagesLabels.IMPORTANT_INSTRUCTION}
              </label>
              <CKEditor
                editor={ClassicEditor}
                data={impInstruction}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setImpInstruction(data);
                }}
              />
            </div>

            <div className="col-md-12 ">
              <label className="LeftText mb-2 fw-bold ms-2">
                {applicationstagesLabels.INSTRUCTIONS_FOR_CANDIDATE}
              </label>
              <CKEditor
                editor={ClassicEditor}
                data={candidateInstruction}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setCandidateInstruction(data);
                }}
              />
            </div>
          </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={cancelModal}
                    >
                        {applicationstagesLabels.BUTTON_CANCEL}
                    </button>
                    {save ? (<button
                        className=" btn btn-primary custom_button   "
                        type="submit"
                        onClick={handleSubmit}
                    >
                        {applicationstagesLabels.SAVE}
                    </button>) : (<button
                        className=" btn btn-primary custom_button   "
                        type="submit"
                        disabled={save || !formState.isValid}
                        onClick={handleSubmit}
                    >
                        {applicationstagesLabels.SAVE}
                    </button>)}
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default AddTimeTable;
